import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Spinner, Card } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { Get, Post, Put } from '../../../../utils/httpProvider';
import { NHANXETHOIDONG_API } from '../../../../utils/apiUrl';
import { loaiDanhGiaValue, thoiGianDanhGiaValue } from '../../../../utils/define';
import moment from 'moment';

const NhanXetHoiDongForm = ({ baoVeCapVienId, readOnly = false, isUserView = false }) => {
    const [saving, setSaving] = useState(false);
    
    const [nhanXetHoiDongId, setNhanXetHoiDongId] = useState(null);
    const [ketQua, setKetQua] = useState(loaiDanhGiaValue.dat);
    const [soBanNhanXet, setSoBanNhanXet] = useState('');
    const [ngayNhanXetMuon, setNgayNhanXetMuon] = useState('');
    const [lucDanhGia, setLucDanhGia] = useState(thoiGianDanhGiaValue.truoc);
    const [isKetQuaDatDuoc, setIsKetQuaDatDuoc] = useState(true);
    const [isNeuBatMoi, setIsNeuBatMoi] = useState(true);

    const { data: queryRes, refetch, isLoading } = useQuery(
        ['nhanXetHoiDongData', baoVeCapVienId], 
        () => Get(`${NHANXETHOIDONG_API.GET_BY_BAOVECAPVIEN_ID}/${baoVeCapVienId}`),
        { 
            enabled: !!baoVeCapVienId,
            refetchOnWindowFocus: false 
        }
    );

    useEffect(() => {
        if (queryRes) {
            let item = null;
            if (Array.isArray(queryRes)) {
                item = queryRes[0];
            } else if (queryRes.data && Array.isArray(queryRes.data)) {
                item = queryRes.data[0];
            } else if (queryRes.data?.$values) {
                item = queryRes.data.$values[0];
            } else if (queryRes.data) {
                item = queryRes.data;
            } else {
                item = queryRes;
            }

            if (item && item.id) {
                setNhanXetHoiDongId(item.id);
                setKetQua(item.ketQua || loaiDanhGiaValue.dat);
                setSoBanNhanXet(item.soBanNhanXet || '');
                setNgayNhanXetMuon(item.ngayNhanXetMuon ? moment(item.ngayNhanXetMuon).format('YYYY-MM-DD') : '');
                setLucDanhGia(item.lucDanhGia || thoiGianDanhGiaValue.truoc);
                
                if (item.isKetQuaDatDuoc !== undefined && item.isKetQuaDatDuoc !== null) {
                    setIsKetQuaDatDuoc(item.isKetQuaDatDuoc);
                }
                
                if (item.isNeuBatMoi !== undefined && item.isNeuBatMoi !== null) {
                    setIsNeuBatMoi(item.isNeuBatMoi);
                }
            }
        }
    }, [queryRes]);

    const handleSave = async () => {
        setSaving(true);
        try {
            const payload = {
                BaoVeCapVienId: baoVeCapVienId,
                KetQua: ketQua,
                SoBanNhanXet: soBanNhanXet ? parseInt(soBanNhanXet) : null,
                NgayNhanXetMuon: ngayNhanXetMuon || null,
                LucDanhGia: lucDanhGia,
                IsKetQuaDatDuoc: isKetQuaDatDuoc,
                IsNeuBatMoi: isNeuBatMoi
            };

            if (nhanXetHoiDongId) {
                await Put(NHANXETHOIDONG_API.UPDATE_ITEM, nhanXetHoiDongId, { ...payload, Id: nhanXetHoiDongId });
            } else {
                await Post(NHANXETHOIDONG_API.CREATE, null, payload);
            }

            toast.success('Lưu thông tin thành công!');
            await refetch();
        } catch (error) {
            console.error(error);
            toast.error('Có lỗi xảy ra khi lưu kết quả.');
        } finally {
            setSaving(false);
        }
    };

    if (isLoading) return <div className="text-center p-3"><Spinner animation="border" variant="primary" /></div>;

    return (
        <div className="bg-white p-3 rounded">
            <Card className="mb-3 border-info shadow-sm">
                <Card.Header className="bg-info text-white font-weight-bold">1. Thông tin chung</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Kết quả</Form.Label>
                                <div style={{ pointerEvents: (readOnly || isUserView) ? 'none' : 'auto' }}>
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Đạt"
                                        name="ketQuaNhanXet"
                                        checked={ketQua === loaiDanhGiaValue.dat}
                                        onChange={() => { if (!readOnly && !isUserView) setKetQua(loaiDanhGiaValue.dat); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Không đạt"
                                        name="ketQuaNhanXet"
                                        checked={ketQua === loaiDanhGiaValue.khongDat}
                                        onChange={() => { if (!readOnly && !isUserView) setKetQua(loaiDanhGiaValue.khongDat); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3 border-success shadow-sm">
                <Card.Header className="bg-success text-white font-weight-bold">2. Nhận xét của thành viên trong Hội đồng</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={6} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Số bản nhận xét của thành viên Hội đồng</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={soBanNhanXet}
                                    onChange={(e) => setSoBanNhanXet(e.target.value)}
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Nhập số bản nhận xét..."
                                    disabled={readOnly || isUserView}
                                    className={readOnly || isUserView ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">2.</span> Ngày viết nhận xét bản muộn nhất</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={ngayNhanXetMuon}
                                    onChange={(e) => setNgayNhanXetMuon(e.target.value)}
                                    disabled={readOnly || isUserView}
                                    className={readOnly || isUserView ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={12} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">3.</span> Thời gian đánh giá</Form.Label>
                                <div style={{ pointerEvents: (readOnly || isUserView) ? 'none' : 'auto' }}>
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Trước ngày bảo vệ"
                                        name="lucDanhGia"
                                        checked={lucDanhGia === thoiGianDanhGiaValue.truoc}
                                        onChange={() => { if (!readOnly && !isUserView) setLucDanhGia(thoiGianDanhGiaValue.truoc); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Sau ngày bảo vệ"
                                        name="lucDanhGia"
                                        checked={lucDanhGia === thoiGianDanhGiaValue.sau}
                                        onChange={() => { if (!readOnly && !isUserView) setLucDanhGia(thoiGianDanhGiaValue.sau); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3 border-warning shadow-sm">
                <Card.Header className="bg-warning text-white font-weight-bold">3. Nội dung các văn bản nhận xét luận án</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Đánh giá về nội dung, phương pháp, kết quả, ý nghĩa, độ tin cậy của các kết quả đạt được</Form.Label>
                                <div style={{ pointerEvents: (readOnly || isUserView) ? 'none' : 'auto' }}>
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Có"
                                        name="isKetQuaDatDuoc"
                                        checked={isKetQuaDatDuoc === true}
                                        onChange={() => { if (!readOnly && !isUserView) setIsKetQuaDatDuoc(true); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Không"
                                        name="isKetQuaDatDuoc"
                                        checked={isKetQuaDatDuoc === false}
                                        onChange={() => { if (!readOnly && !isUserView) setIsKetQuaDatDuoc(false); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                </div>
                            </Form.Group>
                        </Col>

                        <Col md={12} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">2.</span> Nêu bật được những luận điểm mới của luận án</Form.Label>
                                <div style={{ pointerEvents: (readOnly || isUserView) ? 'none' : 'auto' }}>
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Có"
                                        name="isNeuBatMoi"
                                        checked={isNeuBatMoi === true}
                                        onChange={() => { if (!readOnly && !isUserView) setIsNeuBatMoi(true); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Không"
                                        name="isNeuBatMoi"
                                        checked={isNeuBatMoi === false}
                                        onChange={() => { if (!readOnly && !isUserView) setIsNeuBatMoi(false); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {!readOnly && !isUserView && (
                <div className="text-right mt-4">
                    <Button variant="success" onClick={() => handleSave()} disabled={saving}>
                        {saving ? <Spinner size="sm" animation="border" className="mr-1" /> : <i className="fas fa-save mr-1"></i>}
                        Lưu thông tin
                    </Button>
                </div>
            )}
        </div>
    );
};

export default NhanXetHoiDongForm;
